import { render, staticRenderFns } from "./ChoosePlanetSlide.vue?vue&type=template&id=35d5ea74"
import script from "./ChoosePlanetSlide.vue?vue&type=script&lang=js"
export * from "./ChoosePlanetSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports